import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import wrapPageElement from './wrapPageElement';

const localeFromPath = (pathname = '') => {
  const [, first] = pathname.split('/');
  const candidate = (first || '').toLowerCase();
  if (['en_gb','fr_fr','de_de','es_es','it_it','ja_jp','pt_pt','zh_cn'].includes(candidate)) {
    return candidate.split('_')[0];
  }
  return 'en';
};

export const onRouteUpdate = ({ location }) => {
  const lang = localeFromPath(location.pathname);
  document.documentElement.setAttribute('lang', lang);
};

export const shouldUpdateScroll = () => true;

export { wrapPageElement };
